import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

export const ObservationTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1B,
  marginBottom: theme.spacing(1)
}));

export const ObservationSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.neutrals.lead
}));

export const ReasonTextField = styled(TextField)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: theme.palette.neutrals.beige1,
    '& fieldset': {
      borderColor: theme.palette.neutrals.beige4
    }
  }
}));

export const SubmitButtonRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%'
}));
